import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Icon from "@amzn/meridian/icon";
import Row from "@amzn/meridian/row";
import React from "react";
import downloadSmallTokens from "@amzn/meridian-tokens/base/icon/download-small";
var LinkContent = function(param) {
    var content = param.content, onDownloadBtnClick = param.onDownloadBtnClick;
    return /*#__PURE__*/ React.createElement(Column, null, content.map(function(knowledgeLink) {
        var _knowledgeLink_title, _knowledgeLink;
        if ((_knowledgeLink_title = knowledgeLink.title) === null || _knowledgeLink_title === void 0 ? void 0 : _knowledgeLink_title.includes("Download Manual")) {
            var _knowledgeLink1;
            return /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Button, {
                type: "link",
                onClick: function() {
                    var _knowledgeLink;
                    return onDownloadBtnClick((_knowledgeLink = knowledgeLink) === null || _knowledgeLink === void 0 ? void 0 : _knowledgeLink.link);
                }
            }, (_knowledgeLink1 = knowledgeLink) === null || _knowledgeLink1 === void 0 ? void 0 : _knowledgeLink1.title, /*#__PURE__*/ React.createElement(Icon, {
                tokens: downloadSmallTokens
            })));
        }
        // eslint-disable-next-line react/no-array-index-key
        return /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement(Button, {
            type: "link",
            onClick: function() {
                var _knowledgeLink;
                return window.open((_knowledgeLink = knowledgeLink) === null || _knowledgeLink === void 0 ? void 0 : _knowledgeLink.link);
            }
        }, (_knowledgeLink = knowledgeLink) === null || _knowledgeLink === void 0 ? void 0 : _knowledgeLink.title));
    }));
};
export default LinkContent;

//# sourceMappingURL=LinkContent.js.map